export default __webpack_public_path__ + "static/media/sanitation.e2fc83e9.png";